/**
 * 内置示例文档（便于打开即见效果，不必先找文件）。
 * 刻意包含：分组、注释、虚线、旋转文本、无 id 元素、viewBox —— 与 fixtures/messy.svg 同构。
 */
/** 新建空文档：只有画板，没有任何元素 */
export const EMPTY_DOC = [
  '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 800 600" width="800" height="600">',
  '</svg>',
  '',
].join('\n');

export const DEMO_SVG = `<?xml version="1.0" encoding="UTF-8"?>
<!-- 内置示例：可直接改名导出 -->
<svg xmlns="http://www.w3.org/2000/svg" width="600" height="428" viewBox="0 0 600 428">
  <rect id="plate" x="40" y="30" width="520" height="352" fill="#ffffff" stroke="#e6e2da"/>
  <g id="plot">
    <ellipse id="conf" cx="300" cy="212" rx="150" ry="118" fill="#dfeef5" stroke="#7fb6cc" stroke-width="1"/>
    <polyline id="grid-x" points="140,274 460,274" fill="none" stroke="#c9d3d6" stroke-width="1" stroke-dasharray="4 4"/>
    <polyline id="grid-y" points="178,88 178,336" fill="none" stroke="#c9d3d6" stroke-width="1" stroke-dasharray="4 4"/>
    <!-- 分组内的注释也要能原样回存 -->
    <line id="axis-x" x1="140" y1="274" x2="460" y2="274" stroke="#688082" stroke-width="1.2"/>
    <line id="axis-y" x1="178" y1="88" x2="178" y2="336" stroke="#688082" stroke-width="1.2"/>
    <line id="trend" x1="178" y1="336" x2="430" y2="150" stroke="#7f6ad6" stroke-width="1.4" stroke-dasharray="5 4"/>
    <g id="dots">
      <circle id="d1" cx="262" cy="158" r="4" fill="#5aa8c4" stroke="#ffffff" stroke-width="1"/>
      <circle id="d2" cx="276" cy="150" r="4" fill="#cf4b3a" stroke="#ffffff" stroke-width="1"/>
      <circle id="d3" cx="318" cy="214" r="4" fill="#5aa8c4" stroke="#ffffff" stroke-width="1"/>
      <circle id="d4" cx="392" cy="176" r="4" fill="#cf4b3a" stroke="#ffffff" stroke-width="1"/>
    </g>
  </g>
  <text id="title" x="300" y="58" text-anchor="middle" font-size="13" fill="#1b1f24">Principal Coordinates Analysis</text>
  <text id="label-x" x="300" y="378" text-anchor="middle" font-size="10" fill="#4d5560">PCoA1 (23.3%)</text>
  <text x="132" y="216" text-anchor="middle" font-size="10" fill="#4d5560" transform="rotate(-90 132 216)">PCoA2 (15.1%)</text>
  <text id="legend" x="252" y="407" font-size="9.5" fill="#4d5560">Compartment · Rhizosphere · RootEndosphere</text>
</svg>
`;
